import { Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import IconTimes from "../../../common/components/icons/IconTimes";
import actions from "../../actions";

class DetailModal extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.componentDidMountAction !== undefined)
            this.props.componentDidMountAction();
    }

    render({ body, handleClose }) {
        return (
            <div class="fxs_c_details fxs_modal-open">
                <div class="fxs_c_detail-wrapper">
                    <div class="fxs_c_body">
                        <button
                            type="button"
                            onclick={handleClose}
                            class="fxs_modal_close fxs_btn_icon fxs_btn_functional close"
                        >
                            <IconTimes />
                        </button>
                        {body}
                    </div>
                </div>
            </div>
        );
    }
}

export default connectWithTranslations(actions)(DetailModal);
